export const GET_ELEMENTS_DIALOG = "GET_ELEMENTS_DIALOG";
export const RESET_ELEMENTS_DIALOG = "RESET_ELEMENTS_DIALOG";
export const SET_ELEMENTS_DIALOG = "SET_ELEMENTS_DIALOG";
